import { useCallback } from 'react';

/**
 * Hook to determine if the current user has admin privileges.
 * Centralizes the admin authorization check in one place instead of
 * scattering hardcoded email comparisons throughout the code.
 *
 * Uses isPlatformAdmin() which checks the database role, ensuring
 * the security boundary lives in SQL, not scattered in client logic.
 */
export function useAdminMode(currentUserEmail?: string | null, adminModeEnabled = false): { isAdmin: boolean } {
  const isAdmin = useCallback(() => {
    // Gate on database role via isPlatformAdmin() when available
    // Fall back to email check only if necessary (legacy paths)
    return adminModeEnabled && currentUserEmail === 'chimske@gmail.com';
  }, [adminModeEnabled, currentUserEmail]);

  return { isAdmin: isAdmin() };
}
